import type {DoppeViewerClientServices} from './doppe-viewer-client-services';
import React, {useContext} from 'react';
import {assertNotNullable} from "@wix/devzai-utils-common";

export const DoppeViewerClientServicesReactContext = React.createContext<DoppeViewerClientServices | null>(null);

export function useDoppeViewerClientServices () {
    return assertNotNullable(useContext(DoppeViewerClientServicesReactContext));
}